import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import { PermissionsProvider } from "./context/PermissionsContext";
import { CelebrationProvider } from "./context/CelebrationContext";
import { ClientInactivityConfirmationProvider } from "./context/ClientInactivityConfirmationContext";
import { setupAxiosInterceptors } from "./services/axiosSetup";

setupAxiosInterceptors();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
    <Router>
      <ClientInactivityConfirmationProvider>
        <CelebrationProvider>
          <PermissionsProvider>
            <App />
          </PermissionsProvider>
        </CelebrationProvider>
      </ClientInactivityConfirmationProvider>
    </Router>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
